// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bE","header":"bF","container":"bG","greenLink":"bH"};